/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Spreadsheet_DownloadInputs */



/**
* | output |
* | --- |
* | "Download" |
*
* @param {Spaces_Spreadsheet_DownloadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_spreadsheet_download = /** @type {((inputs?: Spaces_Spreadsheet_DownloadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Spreadsheet_DownloadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Herunterladen")
	return /** @type {LocalizedString} */ ("Download")
});